<ix-modal-header>{{
  'dpp.handover_documentation.modal.add_document_modal_title' | translate
}}</ix-modal-header>

<ix-modal-content>
  <form [formGroup]="documentForm">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <ix-typography format="label" class="opacity-75">{{
        'dpp.handover_documentation.modal.document_title' | translate
      }}</ix-typography>
      <ix-button
        icon="add-circle"
        variant="secondary-ghost"
        onkeypress=""
        (click)="addLanguageTitle()"
        >{{
          'dpp.handover_documentation.modal.add_language' | translate
        }}</ix-button
      >
    </div>
    <div formArrayName="languageTitles">
      @for (item of languageTitles.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="d-flex mb-3">
          @if (languageTitles.length > 1) {
            <ix-icon-button
              icon="trashcan"
              onkeypress=""
              (click)="removeLanguageTitle(i)"
            ></ix-icon-button>
          }
          <div class="document-frame position-relative flex-grow-1">
            <ix-select
              class="w-100 mb-2"
              [label]="
                'dpp.handover_documentation.modal.document_language' | translate
              "
              formControlName="documentLanguage"
              [id]="'documentLanguageInput_' + i"
            >
              @for (lang of getAvailableLanguagesForRow(i); track lang.value) {
                <ix-select-item
                  [label]="lang.label + ' (' + lang.value + ')'"
                  [value]="lang.value"
                ></ix-select-item>
              }
            </ix-select>
            <ix-input
              class="w-100"
              [label]="
                'dpp.handover_documentation.modal.document_title' | translate
              "
              formControlName="documentTitle"
              [id]="'documentTitleInput_' + i"
            ></ix-input>
          </div>
        </div>
      }
    </div>
    <ix-select
      class="w-100 mb-3"
      [label]="'dpp.handover_documentation.modal.document_category' | translate"
      formControlName="category"
      id="documentCategory"
    >
      @for (category of categories; track category.value) {
        <ix-select-item
          [label]="category.labelKey | translate"
          [value]="category.value"
        ></ix-select-item>
      }
    </ix-select>

    <ix-select
      class="w-100 mb-3"
      [label]="'dpp.handover_documentation.modal.document_language' | translate"
      formControlName="language"
      id="documentLanguage"
    >
      @for (lang of allLanguages; track lang.value) {
        <ix-select-item
          [label]="lang.label + ' (' + lang.value + ')'"
          [value]="lang.value"
        ></ix-select-item>
      }
    </ix-select>

    <ix-date-input
      class="w-100 mb-3"
      [label]="'dpp.handover_documentation.modal.document_date' | translate"
      formControlName="date"
      id="documentDate"
    ></ix-date-input>

    <ix-input
      class="w-100 mb-3"
      [label]="'dpp.handover_documentation.modal.document_version' | translate"
      formControlName="version"
      id="documentVersion"
    ></ix-input>

    <div class="d-flex align-items-center gap-1 my-3">
      <ix-typography format="label" id="documentUploadLabel">
        {{
          'dpp.handover_documentation.modal.upload_document_label' | translate
        }}
      </ix-typography>
      <ix-icon name="info" size="16"></ix-icon>
    </div>
    <ix-upload
      (filesChanged)="onFilesChanged($event)"
      id="documentUpload"
      accept="application/pdf"
      [state]="uploadState"
      [selectFileText]="
        'dpp.handover_documentation.modal.upload_drag_text' | translate
      "
      [i18nUploadFile]="
        'dpp.handover_documentation.modal.upload_file_placeholder' | translate
      "
      [loadingText]="
        'dpp.handover_documentation.modal.upload_loading_text' | translate
      "
      [uploadFailedText]="
        'dpp.handover_documentation.modal.upload_failed'
          | translate: {error_message: uploadErrorMessage}
      "
      [uploadSuccessText]="
        'dpp.handover_documentation.modal.upload_success' | translate
      "
    ></ix-upload>
    @if (selectedFile) {
      <ix-typography class="mt-2" format="caption">
        {{
          'dpp.handover_documentation.modal.file_selected'
            | translate: {name: selectedFile.name}
        }}
      </ix-typography>
    }
  </form>
</ix-modal-content>

<ix-modal-footer>
  <ix-button
    variant="secondary"
    class="dismiss-modal"
    id="cancelButton"
    onkeypress=""
    (click)="onCancel()"
    [disabled]="isSubmitting"
  >
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    class="dismiss-modal"
    id="addButton"
    onkeypress=""
    (click)="onSubmit()"
    [disabled]="isAddButtonDisabled()"
    [loading]="isSubmitting"
  >
    {{ 'general.save' | translate }}
  </ix-button>
</ix-modal-footer>
